// extracted by mini-css-extract-plugin
export default {"headerRight":"index_headerRight__oDgPX","stopWrapper":"index_stopWrapper__pZCP9"};